module.exports = __webpack_public_path__ + "dlssrvtline2/img/th-slider-2.jpg?fefb8b57";